import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { Spacing, SurfaceContext } from '../../Surface';
import { css } from '../../Util';
export class CustomHeader extends React.Component {
    render() {
        return (React.createElement(SurfaceContext.Consumer, null, surfaceContext => {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: css(this.props.className, "bolt-header flex-row flex-noshrink flex-start", surfaceContext.horizontalClassName, surfaceContext.spacing === undefined && "bolt-header-no-spacing-defined", surfaceContext.spacing === Spacing.condensed && "bolt-header-condensed", surfaceContext.spacing === Spacing.default && "bolt-header-default", surfaceContext.spacing === Spacing.relaxed && "bolt-header-relaxed") }, this.props.children),
                this.props.separator && React.createElement("div", { className: "bolt-header-separator flex-noshrink" })));
        }));
    }
}
